import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Icon, UilChartPie } from '@iconscout/react-unicons';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  moduleName?: string;
  action?: string;
  actionName?: string | string[];
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  count?: number;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export const routes: RouteItems[] = [
  {
    label: 'dashboard',
    horizontalNavLabel: 'home',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      // {
      //   name: 'Dashboard ',
      //   icon: 'pie-chart',
      //   path: '/ ',
      //   pathName: 'project-management-dashbaord',
      //   active: true,
      //   flat: true
      // },
      {
        name: 'Payments',
        icon: 'database',
        active: true,
        flat: true,
        pages: [
          {
            name: 'Quick Payment',
            path: '/',
            active: true
          },
          {
            name: 'Quick Payment List',
            path: '/payments/quick-payment-list',
            pathName: 'quick-payment-list',
            active: true
          }
        ]
      },
      {
        name: 'Cargo FL Challans',
        icon: 'credit-card',
        active: true,
        flat: true,
        pages: [
          {
            name: 'Coal/Iron Ore',
            pathName: 'Coal/Iron Ore',
            active: true,
            pages: [
              {
                name: 'Payment Pending',
                path: '/challans/coal-iron-ore/payment-pending',
                pathName: 'Payment Pending',
                active: true
              },
              {
                name: 'Payment Initiated',
                path: '/challans/coal-iron-ore/payment-initiated',
                pathName: 'Payment Initiated',
                active: true
              }
            ]
          },
          {
            name: 'FlyAsh',
            pathName: 'Coal/Iron Ore',
            active: true,
            pages: [
              {
                name: 'Payment Pending',
                path: '/challans/flyAsh/payment-pending',
                pathName: 'Payment Pending',
                active: true
              },
              {
                name: 'Payment Initiated',
                path: '/challans/flyAsh/payment-initiated',
                pathName: 'Payment Initiated',
                active: true
              }
            ]
          },
          {
            name: 'Create Challan',
            path: '/challans/create-challan',
            pathName: 'new-bills',
            active: true
          },
          {
            name: 'Challans List',
            path: '/challans/challan-list',
            pathName: 'under-process',
            active: true
          }
        ]
      }
    ]
  }
];
